module.exports = __webpack_public_path__ + "51c5ec65136f7e105c5e10702a934097.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/assets/left-fold.svg
 ** module id = 815
 ** module chunks = 0
 **/